import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { useAdminContext } from "../../hooks/UseAdminContext";
import { useSnackbar } from "notistack";
import { _auth_api } from "../../DAL/Login/Login";

export default function AuthPrompt() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { setIsAuthenticated, setIsOpenAuthModal, isOpenAuthModal } =
    useAdminContext();

  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async () => {
    setLoading(true);
    const postData = { username, password, type: 1 };
    const result = await _auth_api(postData);
    if (result.code === 200) {
      sessionStorage.setItem("is_authenticated", "true"); // Save in session storage
      setIsAuthenticated(true);
      setIsOpenAuthModal(false);
      setLoading(false);
      enqueueSnackbar("Authentication successful!", { variant: "success" });
    } else {
      setLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  return (
    <Dialog open={isOpenAuthModal} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ pb: 1, color: "text.primary" }}>
        <h3 className="mb-0">Authentication Required</h3>
      </DialogTitle>
      <DialogContent sx={{ pb: 0 }}>
        <TextField
          autoFocus
          fullWidth
          size="small"
          margin="dense"
          variant="outlined"
          label="User Name"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <TextField
          fullWidth
          size="small"
          margin="dense"
          type="password"
          variant="outlined"
          label="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 2, pt: 1 }}>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={loading}
          size="small"
          sx={{ textTransform: "none", minWidth: 100 }}
        >
          {loading ? <CircularProgress size={16} color="inherit" /> : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
